import React from "react";
import { getDeliveryMethodTitle, getDeliveryDistance, getTotalDeliveryCost, isAvailable, } from "../utils/delivery";
import { formatPrice } from "../utils/helpers";
import CustomerInformationInputType from "../constants/customer-information-input-type";
export default ({ data, deliveryOption, address, onDeliveryOptionClick, }) => {
    const isAutomaticAddress = data.customer.inputType === CustomerInformationInputType.AUTOMATIC;
    if (!isAvailable(deliveryOption, address, isAutomaticAddress)) {
        return (React.createElement("li", { className: "option-list-item" },
            React.createElement("button", { className: "option-list-action", disabled: true },
                React.createElement("div", { "data-ecom-columnrow": "" },
                    React.createElement("div", { className: "column" },
                        React.createElement("div", { className: "option-list-action-title" },
                            getDeliveryMethodTitle(deliveryOption.type),
                            React.createElement("i", { className: "icon-arrow-right m-l-half" })),
                        React.createElement("div", { className: "option-list-action-meta" }, "Hemleverans ej m\u00F6jlig"))))));
    }
    const addressDistance = address !== null ? address.distance : undefined;
    const distance = getDeliveryDistance(addressDistance, deliveryOption);
    const totalDeliveryCost = getTotalDeliveryCost(addressDistance, deliveryOption);
    const hasUnitPrice = typeof deliveryOption.unitPrice === "number" &&
        deliveryOption.unitPrice > 0;
    return (React.createElement("li", { className: "option-list-item" },
        React.createElement("button", { className: "option-list-action", onClick: () => onDeliveryOptionClick(deliveryOption) },
            React.createElement("div", { "data-ecom-columnrow": "" },
                React.createElement("div", { className: "column" },
                    React.createElement("div", { className: "option-list-action-title" },
                        getDeliveryMethodTitle(deliveryOption.type),
                        React.createElement("i", { className: "icon-arrow-right m-l-half" })),
                    React.createElement("div", { className: "option-list-action-meta" },
                        totalDeliveryCost && (React.createElement(React.Fragment, null,
                            formatPrice(totalDeliveryCost),
                            " kr",
                            React.createElement("span", { className: "m-l-mini" },
                                "(Ber\u00E4knat p\u00E5 ",
                                distance,
                                " ",
                                deliveryOption.unit,
                                " \u00E1",
                                " ",
                                formatPrice(deliveryOption.unitPrice),
                                " ",
                                "kr/",
                                deliveryOption.unit,
                                " och en startkostnad p\u00E5",
                                " ",
                                formatPrice(deliveryOption.startupCost),
                                " ",
                                "kr)"))),
                        !totalDeliveryCost && hasUnitPrice && (React.createElement(React.Fragment, null,
                            "Startkostnad:",
                            " ",
                            formatPrice(deliveryOption.startupCost),
                            " kr",
                            " ",
                            "+",
                            formatPrice(deliveryOption.unitPrice),
                            " kr/",
                            deliveryOption.unit)),
                        !hasUnitPrice && (React.createElement(React.Fragment, null,
                            formatPrice(deliveryOption.startupCost),
                            " kr"))))))));
};
